/* global gsap ScrollTrigger */

gsap.registerPlugin(ScrollTrigger);
window.expandScroll = {};

let __es = window.expandScroll;

__es.init = function (container) {
	gsap.to(container, {
		scrollTrigger: {
			trigger: container,
			toggleClass: 'active',
			start: 'top 70%',
			end: 'bottom 30%',
			preventOverlaps: true
		}
	});
};

__es.main = function () {
	let triggerSelectors = '.aboutusanimation, .gallarymainclass, .image_spacer figure img';

	let containers = document.querySelectorAll(triggerSelectors);

	containers.forEach(__es.init);
};

__es.main();
